// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1174389e]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.app-main[data-v-1174389e]{height:calc(100vh - 94px);width:100%;position:relative;overflow-y:auto;padding:0 10px 10px 10px;background-color:#f7f8fa}.fixed-header+.app-main[data-v-1174389e]{padding-top:50px;height:100vh;overflow:auto}", ""]);
// Exports
module.exports = exports;
